angular.module("open-iti", ["services"]);
